import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-radv-dos-ranking-hcc-dw",
  templateUrl: "./radv-dos-ranking-hcc-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadvDosRankingHccDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RADV_DOS_RANKING_HCC;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME];
}
